import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex justify-start mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "block text-lg font-robotoBold mb-2" }, " Possible ideas to help you ", -1)
const _hoisted_3 = {
  key: 0,
  class: "mb-16 py-5"
}
const _hoisted_4 = { class: "mt-2 mb-2 flex justify-center" }
const _hoisted_5 = { class: "w-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Fetching possible ideas...", -1)
const _hoisted_7 = {
  key: 1,
  class: "mb-6 sm:mb-2"
}
const _hoisted_8 = { class: "text-base mr-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "whitespace-nowrap" }, "Use this", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "flex justify-center" }
const _hoisted_13 = {
  key: 1,
  class: "flex flex-row justify-center mt-8 mb-6"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Sorry, we were unable to generate any possible ideas for you.", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_RefreshIcon = _resolveComponent("RefreshIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AppButton, {
        type: "secondary",
        disabled: _ctx.hasInitialDescription,
        onClick: _withModifiers(_ctx.handleResetDescription, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Reset ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _hoisted_2,
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_LoadingIcon)
            ])
          ]),
          _hoisted_6
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.possibleIdeas.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.possibleIdeas, (idea, ideaIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: ideaIndex,
                    class: "sm:flex items-center p-4 mb-3 border-2 border-cebai-grey-light rounded-lg"
                  }, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(idea.content), 1),
                    _createElementVNode("button", {
                      class: "mt-2 sm:mt-0 text-base text-cebai-primary font-robotoMedium hover:underline hover:decoration-cebai-primary hover:underline-offset-4",
                      onClick: _withModifiers(() => _ctx.adoptPossibleIdea(idea.content), ["prevent"])
                    }, _hoisted_11, 8, _hoisted_9)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_AppButton, {
                    type: "secondary",
                    onClick: _withModifiers(_ctx.fetchPossibleIdeas, ["prevent"])
                  }, {
                    iconBefore: _withCtx(() => [
                      _createVNode(_component_RefreshIcon, { class: "mr-2 fill-current" })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Refresh ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
        ]))
  ], 64))
}